(function () {
  var fixedEl = document.getElementById('rw-hdr-fixed');
  var spacerEl = document.getElementById('rw-hdr-spacer');
  /* W7-1: --rw-header-h volgt de ACTUELE hoogte (compact of niet) voor sticky-offsets/autoscroll;
     de spacer houdt de VOLLE hoogte zodat de pagina niet springt als de header inklapt. */
  function syncH() {
    if (!fixedEl) return;
    var h = Math.round(fixedEl.getBoundingClientRect().height * 2) / 2; /* Mobile-gate r1 tip 3: 110,5 → geen 0,5px-naad tussen header en gepinde balken */
    if (h) document.documentElement.style.setProperty('--rw-header-h', h + 'px');
  }
  /* W10-1a gate r3 (Mobile B-2): tijdens de header-transitie (topbar/zoekrij klappen in of uit) elke frame de
     werkelijke hoogte naar --rw-header-h schrijven, zodat gepinde balken (top: var(--rw-header-h)) met de
     onderkant van de header meebewegen i.p.v. 42px te zweven en daarna te springen. Stopt zodra de hoogte
     drie frames stabiel is (max ~500ms). */
  /* W10-1a gate r3 (Mobile B-2): bij een staatwissel meteen de EINDhoogte van de header in --rw-header-h zetten
     (noanim-snapshot: onderdelen springen naar hun doel, meten, transitie hervat vanaf de snapshot — zelfde techniek
     als measure()). De gepinde balken krijgen zelf `transition: top .22s ease`, dus zij bewegen synchroon met de
     inklap i.p.v. 42px te zweven en daarna te springen. syncH() na 300ms als vangnet. */
  var syncT2 = null;
  function syncFinal() {
    if (!fixedEl) return;
    var parts = [].slice.call(fixedEl.querySelectorAll('.rw-topbar, .rw-msearchrow'));
    var snap = parts.map(function (e) { return [e, e.getBoundingClientRect().height]; });
    fixedEl.classList.add('rw-noanim');
    var h = Math.round(fixedEl.getBoundingClientRect().height * 2) / 2;
    snap.forEach(function (sn) { sn[0].style.transition = 'none'; sn[0].style.maxHeight = sn[1] + 'px'; });
    void fixedEl.offsetHeight;
    fixedEl.classList.remove('rw-noanim');
    snap.forEach(function (sn) { sn[0].style.transition = ''; sn[0].style.maxHeight = ''; });
    if (h) document.documentElement.style.setProperty('--rw-header-h', h + 'px');
    clearTimeout(syncT2); syncT2 = setTimeout(syncH, 300);
  }
  function syncRun() { syncFinal(); }
  function measure() {
    if (!fixedEl) return;
    /* W7-3 gate r3 (Mobile B1): de noanim-meetflits annuleerde een lopende band-transitie
       (checkPastHero -> measure op dezelfde scroll) waardoor de topbar op de home snapte
       i.p.v. animeerde. Snapshot vooraf; wijkt de hoogte na de meting af, dan hervat de
       transitie vanaf de snapshot (beide richtingen; reduced-motion clipt dit naar instant). */
    /* Mobile-gate r2 B-3: measure draaide vóór de is-nosr-toggle van de andere resize-listener → blijvende 54px-desync
       bij 768↔390/641 (Split View/foldables). De klasse hier zelf actueel maken maakt de volgorde irrelevant. */
    if (typeof rwStartCompact === 'function') fixedEl.classList.toggle('is-nosr', rwStartCompact());
    var rwTbM = fixedEl.querySelector('.rw-topbar');
    var rwTbH0 = rwTbM ? rwTbM.getBoundingClientRect().height : null;
    var wasCompact = fixedEl.classList.contains('is-compact');
    var wasMid = fixedEl.classList.contains('is-mid'); /* Mobile-gate r2 B-3: is-mid hield de topbar dicht tijdens de meting → spacer op de compacte hoogte */
    fixedEl.classList.add('rw-noanim'); /* vóór elke klassenwissel, anders meet offsetHeight mid-transitie */
    if (wasMid) fixedEl.classList.remove('is-mid');
    if (wasCompact) fixedEl.classList.remove('is-compact');
    var full = fixedEl.offsetHeight;
    if (wasMid) fixedEl.classList.add('is-mid');
    if (wasCompact) fixedEl.classList.add('is-compact');
    void fixedEl.offsetWidth; fixedEl.classList.remove('rw-noanim');
    if (rwTbM && rwTbH0 !== null) {
      var rwTbH1 = rwTbM.getBoundingClientRect().height;
      if (Math.abs(rwTbH1 - rwTbH0) > 0.5) {
        rwTbM.style.transition = 'none'; rwTbM.style.maxHeight = rwTbH0 + 'px'; void rwTbM.offsetHeight;
        rwTbM.style.transition = ''; rwTbM.style.maxHeight = '';
      }
    }
    if (full) {
      document.documentElement.style.setProperty('--rw-header-full', full + 'px');
      /* W10-1a (Principal r1 B4, spiegel verkoop W9-2): waar de header compact start reserveert de spacer de COMPACTE
         hoogte — anders staat er 96px leeg vlak boven het kruimelpad. */
      if (spacerEl) spacerEl.style.height = full + 'px'; /* is-nosr (zoekrij weg) zit al in de gemeten volle hoogte */
    }
    syncH();
  }
  /* W10-1a (Principal r1 B4 — één headerregel voor beide sites, spiegel verkoop W9-2 Mobile-gate r2/r3): productpagina,
     winkelwagen en collecties op telefoon en lage/landscape-viewports starten compact en BLIJVEN compact bij omhoog
     scrollen (topbar + zoekrij kostten 96px van de fold waar conditie en prijs in moeten). Zoeken blijft 1 tik via het
     icoon in de hoofdbalk; de Kopen/Verkopen-switch staat in het menu. Body-classes heten template-<naam>(-<suffix>). */
  function rwStartCompact() {
    return (/(^| )template-(product|cart|collection)(-|\s|$)/.test(document.body.className) && window.matchMedia('(max-width: 760px)').matches) || window.matchMedia('(max-height: 520px)').matches;
  }
  var measureFrame = null;
  function queueMeasure() {
    if (measureFrame !== null) return;
    measureFrame = requestAnimationFrame(function () { measureFrame = null; measure(); });
  }
  measure();
  window.addEventListener('resize', queueMeasure);
  var rwRzT = null; window.addEventListener('resize', function () { clearTimeout(rwRzT); rwRzT = setTimeout(measure, 260); }); /* W10-1a gate r4 (Mobile tip 1): na rotatie vanaf een tablet-topbar week --rw-header-h 12px af (meting vóór de herlayout) — nameten als de resize tot rust is */
  window.addEventListener('load', measure);
  setTimeout(measure, 300);

  /* W7-1 (directive par.10 + Mobile-gate-tips W6-3/W6-7): compact bij omlaag scrollen —
     de trust-topbar (en op telefoon de zoekrij) klappen in; hoofdbalk + catbar blijven.
     Omhoog scrollen of focus in de header klapt direct weer uit. */
  (function () {
    if (!fixedEl || !document.body.classList.contains('rw-redesign')) return;
    var lastY = window.pageYOffset, down = 0, up = 0, syncT = null;
    var startCompact = rwStartCompact();
    window.addEventListener('resize', function () { startCompact = rwStartCompact(); fixedEl.classList.toggle('is-nosr', startCompact); if (window.pageYOffset < 120) { setCompact(false); setMid(false); } queueMeasure(); }); /* Mobile-gate r1 tip 4 + r2 B-3: staat én spacer volgen de nieuwe maat (split-view/rotatie) */
    function tbPulse() { /* W7-3 Mobile-gate B2: overgang verticaal geclipt; rust = open voor het 44px-tapdoel */
      var rwTb = fixedEl.querySelector('.rw-topbar');
      if (rwTb) { rwTb.classList.add('rw-tb-anim'); clearTimeout(rwTb.__rwTbT); rwTb.__rwTbT = setTimeout(function () { rwTb.classList.remove('rw-tb-anim'); }, 260); }
    }
    function setMid(on) { /* W10-1a: ook de is-mid-overgangen (dicht blijven / weer openen bij de top) lopen geclipt */
      if (fixedEl.classList.contains('is-mid') === on) return;
      fixedEl.classList.toggle('is-mid', on); tbPulse();
      syncRun(); /* W10-1a gate r3 (Mobile B-2): --rw-header-h liep per frame mee met de 220ms-inklap (was: pas na 260ms → gepinde balk zweefde ~250ms 42px onder de header en sprong daarna) */
    }
    function setCompact(on) {
      if (fixedEl.classList.contains('is-compact') === on) return;
      fixedEl.classList.toggle('is-compact', on);
      tbPulse();
      syncRun(); /* W10-1a gate r3 (Mobile B-2): per frame mee met de inklap-transitie */
    }
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset, dy = y - lastY; lastY = y;
      if (document.body.style.overflow === 'hidden') return; /* overlay open: niets doen */
      if (y < 120) { /* Mobile-gate r1 tip 1: bij een sprong naar de top (Naar boven) direct de volle hoogte — geen 96px-band tijdens de animatie */
        var sprong = Math.abs(dy) > 300; if (sprong) fixedEl.classList.add('rw-noanim');
        setCompact(false); setMid(false); down = 0; up = 0;
        if (sprong) { void fixedEl.offsetWidth; requestAnimationFrame(function () { requestAnimationFrame(function () { fixedEl.classList.remove('rw-noanim'); }); }); }
        return; }
      if (Math.abs(dy) < 2) return; /* momentum-ruis */
      if (dy > 0) { down += dy; up = 0; if (down > 36) setCompact(true); }
      else { up -= dy; down = 0; if (up > 72) { fixedEl.classList.add('is-mid'); setCompact(false); } } /* W7-1 Principal-tip: stevige hysterese — kleine opwaartse correcties laten de topbar niet terugveren */
      /* W10-1a (Mobile r9-tip, 320×568 gemeten 167px stack): halverwege de pagina omhoog scrollen brengt op telefoon
         alleen hoofdbalk + zoekrij terug (is-mid); de trust-topbar komt pas weer bij de paginatop. Desktop ongewijzigd. */
    }, { passive: true });
    /* W10-1a gate r1 (Principal B4 / Mobile B6 / E-com B2 — drie onafhankelijke meldingen): op product/cart/collectie (telefoon) en lage
       viewports blijft de trust-topbar (score + Kopen|Verkopen) aan de paginatop; alleen de zoekrij (54px) blijft weg (is-nosr) —
       zoeken 1 tik via het icoon. Omlaag scrollen klapt de topbar in (compact), omhoog scrollen brengt hem pas terug aan de top (is-mid). */
    fixedEl.classList.toggle('is-nosr', startCompact);
    if (startCompact) measure();
    fixedEl.addEventListener('focusin', function (e) {
      /* W7-1 gate r1 (A11y V1/Impatient B1): het compacte zoekicoon zelf mag de header NIET laten
         uitklappen — de expand verborg het icoon mid-tap waardoor de click nooit afvuurde. */
      if (e.target.closest && e.target.closest('.rw-msearch--compact, .rw-actions.rw-only-phone .rw-msearch')) return;
      if (e.target.closest && e.target.closest('.rw-bar__wk')) return; /* W10-1b (E-com r3/r4 T-8): de score-chip staat in elke staat in de hoofdbalk — focus erop (mousedown vóór het reviewvenster) mag de header niet van compact naar is-mid schuiven */
      /* W10-1a A11y-gate r1 (B1/tip 3): focus in een gescrolde header brengt alleen hoofdbalk (+ zoekrij op telefoon) terug
         (is-mid) — de topbar blijft dicht en de score-chip blijft bestaan (was: de chip verdween tussen mousedown en click,
         en elke Tab door de header schoof de content 30px). Alleen focus op een (geclipt) topbar-element opent de topbar. */
      if (e.target.closest && e.target.closest('.rw-topbar')) { setMid(false); setCompact(false); return; }
      if (fixedEl.classList.contains('is-compact') || fixedEl.classList.contains('is-mid')) { fixedEl.classList.add('is-mid'); setCompact(false); }
    });
  })();

  /* W7-2 gate r7 (Mobile B1): op de zoekpagina is de mobiele zoekrij bewust vervangen door het
     paginazoekveld (r3, één zichtbaar veld). Maar zodra dat veld uit beeld scrolt moet de header
     in ELKE scrollstaat een zoekingang houden — ook in de niet-compacte tussenstaat (terugscrollen
     op een lange resultatenpagina). Zelfde past-predicaat als de verkoopsite (deterministisch). */
  /* W15-1d gate r1 (Impatient B1): ook de 404 heeft geen zoekrij maar een eigen paginaveld; zonder dit predicaat had de
     tussenstaat (is-mid, terugscrollen) daar géén enkele ingang meer nu het icoon aan de top uit staat. Zelfde logica. */
  function rwPastPageSearchInit() {
    if (!fixedEl || !/(^| )template-(search|404)( |$)/.test(document.body.className)) return;
    var ps = document.querySelector('main .rw-coll-search__input, #MainContent .rw-coll-search__input, main [data-rw-404-q], #MainContent [data-rw-404-q]');
    if (!ps) { fixedEl.classList.add('is-past-ps'); return; }  // fail-safe: geen paginaveld -> icoon altijd tonen
    var was = null;
    function chk() {
      var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--rw-header-h'), 10) || fixedEl.offsetHeight || 160;
      var past = ps.getBoundingClientRect().bottom < hh;
      if (past === was) return;
      was = past;
      fixedEl.classList.toggle('is-past-ps', past);
    }
    chk();
    window.addEventListener('scroll', chk, { passive: true });
    window.addEventListener('resize', chk);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', rwPastPageSearchInit); } else { rwPastPageSearchInit(); }

  // topbar mag NOOIT 2 regels worden: toon de USP-tekst alleen als de regel past, anders weg
  function fitTopbar() {
    var bar = document.querySelector('.rw-topbar__in');
    if (!bar) return;
    var usp = bar.querySelector('.rw-top-hide');
    if (!usp) return;
    usp.style.display = 'flex';                                  // probeer te tonen
    if (bar.scrollWidth > bar.clientWidth + 1) usp.style.display = 'none';   // past niet → weg
  }
  fitTopbar();
  window.addEventListener('resize', fitTopbar);
  window.addEventListener('load', fitTopbar);
  setTimeout(fitTopbar, 300);

  var burger = document.getElementById('rw-burger');
  var drawer = document.getElementById('rw-drawer');
  var dclose = document.getElementById('rw-drawer-close');
  var drawerHist = false; /* W7-2 gate r6 (A11y B4): eigen history-entry — Android-terugknop sluit het menu, niet de site */

  var mnav = document.getElementById('rw-mnav');
  var mstack = ['root'];
  var mfocus = {};
  function mnavFocus(f) { if (!f) return; try { f.focus({ preventScroll: true }); } catch (err) { f.focus(); } }
  function mnavShow(id, dir, left) {
    if (!mnav) return;
    var el = mnav.querySelector('[data-panel="' + id + '"]');
    if (!el) {
      var source = mnav.querySelector('template[data-rw-mnav-template="' + id + '"]');
      var content = source && source.content;
      el = content && content.querySelector('[data-panel="' + id + '"]');
      if (!el) return;
      source.parentNode.replaceChild(content, source);
    }
    mnav.querySelectorAll('.rw-mnav__panel').forEach(function (p) { p.classList.remove('is-active'); });
    el.classList.add('is-active');
    var body = drawer && drawer.querySelector('.rw-drawer__body'); if (body) body.scrollTop = 0;
    /* W15-2c gate-A11y (red-team B2): focus mee laten reizen, spiegel verkoop — anders valt hij op body zodra het oude paneel display:none krijgt (WCAG 2.4.3).
       Vooruit: naar de terugknop van het nieuwe paneel; terug: naar de drilknop die het verlaten paneel opende. */
    if (dir === 'fwd') { mnavFocus(el.querySelector('[data-back]') || el.querySelector('a, button')); }
    else if (dir === 'back') { mnavFocus((left && mfocus[left]) || el.querySelector('.rw-mnav__head') || el.querySelector('a, button')); }
    return true;
  }
  if (mnav) {
    mnav.addEventListener('click', function (e) {
      var go = e.target.closest('[data-go]');
      if (go) { e.preventDefault(); var id = go.getAttribute('data-go'); if (mnavShow(id, 'fwd')) { mfocus[id] = go; mstack.push(id); } return; }
      var back = e.target.closest('[data-back]');
      if (back) { e.preventDefault(); if (mstack.length > 1) { var left = mstack.pop(); mnavShow(mstack[mstack.length - 1], 'back', left); } }
    });
  }

  function setDrawer(open, focusSearch) {
    if (!drawer) return;
    var was = !drawer.hidden;
    var trigger = document.activeElement;
    drawer.hidden = !open;
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open !== was) {
      if (window.rwLockScroll) window.rwLockScroll(open); else document.body.style.overflow = open ? 'hidden' : ''; /* W6-9: gedeelde lock-teller (cart-drawer vanuit het menu) */
      if (open) { try { history.pushState({ rwDrawer: 1 }, ''); drawerHist = true; } catch (err) { drawerHist = false; } }
      else if (drawerHist) { drawerHist = false; try { if (history.state && history.state.rwDrawer) history.back(); } catch (err) {} }
      /* W7-1 (FQE-tip W6-9 r2): drawer als echte dialoog — inert/focus-trap/focus-return via de gedeelde helper */
      if (open && window.rwDialogOpen) window.rwDialogOpen(drawer, { initial: focusSearch ? 'input[type="search"]' : '#rw-drawer-close', trigger: trigger === document.body ? burger : trigger });
      if (!open && window.rwDialogClose) window.rwDialogClose(drawer);
    }
    if (open) { mstack = ['root']; mnavShow('root'); }
    // UX2026: drawer-switch-indicator meten nu hij zichtbaar is
    if (open && typeof rwSwitchPlacers !== 'undefined') rwSwitchPlacers.forEach(function (f) { try { f(); } catch (err) {} });
    if (open && focusSearch && !window.rwDialogOpen) {
      var inp = drawer.querySelector('input[type="search"]');
      if (inp) setTimeout(function () { inp.focus(); }, 60);
    }
  }
  if (burger) burger.addEventListener('click', function () { setDrawer(true); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !drawer || drawer.hidden) return;
    if (window.rwDialogTop && window.rwDialogTop() && window.rwDialogTop() !== drawer) return; /* W7-1: alleen de bovenste dialoog reageert op Escape */
    setDrawer(false); if (burger && !(window.rwDialogClose)) burger.focus();
  }); /* W6-9 FQE-tip; focus-return doet de dialog-helper */
  if (dclose) dclose.addEventListener('click', function () { setDrawer(false); });
  window.addEventListener('popstate', function () {
    if (!drawer || drawer.hidden) return;
    if (searchOv && !searchOv.hidden) return; /* zoekoverlay bóven het menu: die laag gaat eerst (eigen handler) */
    drawerHist = false; setDrawer(false);
  });
  // mobiele fullscreen zoekoverlay
  var searchOv = document.getElementById('rw-search-ov');
  var ovHist = false, ovOpenedAt = 0;
  if (searchOv) {
    /* W7-2 r3: ghost-click-guard — de click die volgt op de openings-tap mag geen chip/rij raken */
    searchOv.addEventListener('click', function (e) {
      if (Date.now() - ovOpenedAt >= 400) return;
      var a = e.target.closest && e.target.closest('a, button');
      if (a && !a.closest('.rw-search-ov__bar')) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }
  var ovTrig = null;
  function ovBtns() { return document.querySelectorAll('#rw-msearchrow-btn, #rw-mob-search, #rw-tab-search, #rw-botnav-search'); }
  function openSearchOv(trig, keepEntry) {
    if (!searchOv) { setDrawer(true, true); return; }   // fallback
    if (!searchOv.hidden) return;
    var restoring = keepEntry === true; /* W7-2 gate r6 (Mobile B1): heropenen op een bestaande history-entry (terug vanaf de productpagina) */
    /* W7-2 gate r4 (Mobile B2): openers op pointerdown vuren vóór focus — expliciete trigger nodig */
    var trigger = (trig && trig.nodeType === 1) ? trig : document.activeElement;
    ovTrig = trigger;
    /* W7-2 gate r4 (Impatient B2): de opener draagt de open-staat van de dialoog */
    Array.prototype.forEach.call(ovBtns(), function (b2) { b2.setAttribute('aria-expanded', 'true'); });
    if (trigger && trigger.getAttribute && trigger.getAttribute('role') === 'combobox') trigger.setAttribute('aria-expanded', 'true'); /* alleen op velden met combobox-rol — aria-expanded is niet geldig op een kale searchbox */
    searchOv.hidden = false; searchOv.setAttribute('aria-hidden', 'false');
    if (window.rwLockScroll) window.rwLockScroll(true); else document.body.style.overflow = 'hidden';
    /* W7-2 r3 (Mobile B3): focus synchroon binnen de tap-gesture, anders opent iOS het toetsenbord niet;
       voorgevulde query (bv. op de zoekpagina) triggert direct suggesties (Impatient B6). */
    var inp0 = searchOv.querySelector('input[type="search"]');
    if (inp0) {
      /* W7-2 gate r6 (Mobile B3): bewaarde tekst staat geselecteerd — typen vervangt, niets plakt aan de oude query */
      if (!restoring) { try { inp0.focus(); } catch (e) {} if (inp0.value) { try { inp0.select(); } catch (e) {} } }
      if (inp0.value.trim().length >= 2) inp0.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (restoring) { ovHist = true; } else { try { history.pushState({ rwSearchOv: 1 }, ''); ovHist = true; } catch (e) {} } /* Android-terugknop sluit de overlay (Mobile-tip 2) */
    ovOpenedAt = Date.now();
    if (window.rwDialogOpen) { window.rwDialogOpen(searchOv, { initial: restoring ? '[data-rw-search-ov-close]' : 'input[type="search"]', trigger: trigger }); return; } /* W7-1: inert/trap/focus-return; bij herstel geen toetsenbord */
    if (inp0 && document.activeElement !== inp0) setTimeout(function () { inp0.focus(); }, 60);
  }
  window.rwOpenSearchOv = openSearchOv;
  /* W7-2 gate r6 (Mobile B1): navigeren vanuit de overlay liet de entry {rwSearchOv} achter — één terugknop vanaf de
     productpagina landde op een "dode" entry (niets zichtbaars). Nu heropent die entry de overlay mét de laatste
     zoekterm ("terug naar mijn zoekresultaten"); de volgende terugknop sluit hem zoals altijd. Entries van losse
     lagen (menu/cart/quick-shop/filters) die niet te herstellen zijn, worden bij het laden direct overgeslagen. */
  if (searchOv) {
    var ovInp = searchOv.querySelector('input[type="search"]');
    if (ovInp) ovInp.addEventListener('input', function () { try { sessionStorage.setItem('rw-ov-q', ovInp.value); } catch (e) {} });
  }
  function rwRestoreLayers() {
    var st0 = null; try { st0 = history.state; } catch (e) {}
    if (!st0) return;
    if (st0.rwSearchOv && searchOv && searchOv.hidden && window.matchMedia('(max-width: 1060px)').matches) {
      var q0 = ''; try { q0 = sessionStorage.getItem('rw-ov-q') || ''; } catch (e) {}
      var inpR = searchOv.querySelector('input[type="search"]');
      if (inpR && q0 && !inpR.value) inpR.value = q0;
      openSearchOv(document.getElementById('rw-msearchrow-btn') || document.getElementById('rw-mob-search') || burger, true);
    } else if (st0.rwSearchOv || st0.rwDrawer || st0.rwLayer) { try { history.back(); } catch (e) {} }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(rwRestoreLayers, 30); }); else setTimeout(rwRestoreLayers, 30);
  window.addEventListener('popstate', function () {
    /* W7-2 gate r3 (Mobile B1): terugknop sluit de BOVENSTE laag — een open quick-shop-sheet eerst;
       de overlay eronder blijft (incl. query/resultaten) en krijgt zijn history-entry terug. */
    if (searchOv && !searchOv.hidden && window.rwQuickShopBackClose && window.rwQuickShopBackClose()) {
      try { history.pushState({ rwSearchOv: 1 }, ''); ovHist = true; } catch (e) {}
      return;
    }
    /* W7-2 gate r5 (E-com-tip): cart-drawer boven de overlay = eigen laag voor de terugknop */
    if (searchOv && !searchOv.hidden && window.rwCartBackClose && window.rwCartBackClose()) {
      try { history.pushState({ rwSearchOv: 1 }, ''); ovHist = true; } catch (e) {}
      return;
    }
    if (searchOv && !searchOv.hidden) { ovHist = false; closeSearchOv(); }
  });
  function closeSearchOv(viaKb) {
    if (!searchOv || searchOv.hidden) return;
    /* W7-2 gate r5 (Impatient-tip 7): getypte query niet weggooien — terug naar het triggerveld */
    if (ovTrig && ovTrig.tagName === 'INPUT') { var ovi2 = searchOv.querySelector('input[type="search"], input[name="q"]'); if (ovi2) ovTrig.value = ovi2.value; }
    /* W7-2 gate r6 (Mobile B3): de zoekrij toont de bewaarde tekst (belooft geen lege zoekopdracht meer) */
    var msrB = document.getElementById('rw-msearchrow-btn'), ovq = searchOv.querySelector('input[type="search"]');
    if (msrB) {
      var qv = ovq ? ovq.value.trim() : '';
      msrB.classList.toggle('is-filled', !!qv);
      Array.prototype.forEach.call(msrB.querySelectorAll('.rw-msr-long, .rw-msr-short'), function (s) { if (!s.hasAttribute('data-ph')) s.setAttribute('data-ph', s.textContent); s.textContent = qv || s.getAttribute('data-ph'); });
    }
    Array.prototype.forEach.call(ovBtns(), function (b2) { b2.setAttribute('aria-expanded', 'false'); });
    if (ovTrig && ovTrig.getAttribute && ovTrig.getAttribute('role') === 'combobox') ovTrig.setAttribute('aria-expanded', 'false');
    if (ovHist) { ovHist = false; try { history.back(); } catch (e) {} } /* verwijder de overlay-history-entry */
    /* W7-2 gate r2 (A11y-tip 12): paneel + statusregio leegmaken zodat een oude melding niet opnieuw wordt aangekondigd */
    var ovRes = searchOv.querySelector('[data-rw-predictive-results]'); if (ovRes) ovRes.hidden = true;
    var ovSt = searchOv.querySelector('[role="status"]'); if (ovSt) ovSt.textContent = '';
    searchOv.hidden = true; searchOv.setAttribute('aria-hidden', 'true');
    if (window.rwLockScroll) window.rwLockScroll(false); else document.body.style.overflow = '';
    if (window.rwDialogClose) window.rwDialogClose(searchOv);
    /* W7-2 gate r4 (Mobile B2): een veld-trigger krijgt de focus alleen via het toetsenbord (Escape)
       terug; bij een tik landt de focus op het formulier — geen ongevraagd soft-toetsenbord. */
    if (ovTrig && ovTrig.tagName === 'INPUT' && viaKb !== true && document.contains(ovTrig)) {
      var fEl = ovTrig.closest('form') || ovTrig.parentElement;
      if (fEl) { fEl.setAttribute('tabindex', '-1'); try { fEl.focus({ preventScroll: true }); } catch (e) {} fEl.addEventListener('blur', function () { fEl.removeAttribute('tabindex'); }, { once: true }); }
    }
    ovTrig = null;
  }
  if (searchOv) {
    searchOv.querySelectorAll('[data-rw-search-ov-close]').forEach(function (b) { b.addEventListener('click', closeSearchOv); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (window.rwDialogTop && window.rwDialogTop() && window.rwDialogTop() !== searchOv) return; /* W7-1: Escape-voorrang bovenste dialoog */
      closeSearchOv(true);
    });
  }

  Array.prototype.forEach.call(ovBtns(), function (b2) { b2.setAttribute('aria-expanded', 'false'); });
  var mobSearch = document.getElementById('rw-mob-search');
  if (mobSearch) mobSearch.addEventListener('click', function () {
    /* W7-2 gate r7 (Mobile B1): op de zoekpagina neemt de overlay de huidige zoekterm mee
       (geselecteerd — typen vervangt), zodat het icoon "zoekopdracht aanpassen" betekent. */
    if (/(^| )template-search( |$)/.test(document.body.className) && searchOv) {
      var psInp = document.querySelector('main .rw-coll-search__input, #MainContent .rw-coll-search__input');
      var ovi3 = searchOv.querySelector('input[type="search"]');
      if (psInp && ovi3 && !ovi3.value && psInp.value) ovi3.value = psInp.value;
    }
    openSearchOv(mobSearch);
  });
  var tabSearch = document.getElementById('rw-tab-search');
  if (tabSearch) tabSearch.addEventListener('click', openSearchOv);
  var bSearch = document.getElementById('rw-botnav-search');
  if (bSearch) bSearch.addEventListener('click', openSearchOv);
  var bCats = document.getElementById('rw-botnav-cats');
  if (bCats) bCats.addEventListener('click', function () { setDrawer(true); });
  if (drawer) drawer.addEventListener('click', function (e) {
    /* cart-drawer vanuit het menu: de menu-entry wordt de cart-entry (geen back() die de nieuwe laag zou poppen) */
    if (e.target.closest('[data-rw-cart-open]')) { drawerHist = false; if (window.rwLayerAdopt) window.rwLayerAdopt(); setDrawer(false); }
  });

  // mega: uitklapbare lange subcategorie-lijsten
  document.querySelectorAll('[data-rw-more]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var more = btn.previousElementSibling;
      if (!more || !more.classList.contains('rw-mega__more')) return;
      var willOpen = more.hidden;
      more.hidden = !willOpen;
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      btn.textContent = willOpen ? 'Minder tonen' : ('+ ' + more.querySelectorAll('a').length + ' meer');
    });
  });

  // Kopen/Verkopen-schakelaar(s): indicator schuift naar de gehoverde kant en wisselt van kleur
  // (Kopen = Reway-blauw, Verkopen = groen). Meerdere instanties (header + drawer, UX2026).
  // W7-3 (directive §9 "subtiele overgang"): vertrek = de indicator schuift direct mee met de klik
  // (navigatie zelf ongemoeid, geen kunstmatige wachttijd); aankomst vanaf de zustersite
  // (document.referrer = standaard browsergedrag, géén cross-domain-sessie/param) = de indicator start
  // op de vorige modus en schuift binnen ~300ms naar de nieuwe. Niet bij reduced-motion of bfcache.
  var rwSwitchPlacers = [];
  var rwSwArriving = false;
  try {
    var rwSwRef = document.referrer ? new URL(document.referrer).hostname : '';
    rwSwArriving = /(^|\.)rewayverkopen\.nl$/.test(rwSwRef) && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (rwSwErr) { rwSwArriving = false; }
  document.querySelectorAll('.rw-switch').forEach(function (sw) {
    var ind = sw.querySelector('.rw-switch__ind');
    var swOpts = sw.querySelectorAll('.rw-switch__opt');
    var swActive = sw.querySelector('.rw-switch__opt.is-on') || swOpts[0];
    var swBuy = swOpts[0]; // "Kopen" = eerste optie = blauw; "Verkopen" = groen
    var swOther = (swOpts[0] === swActive) ? swOpts[1] : swOpts[0];
    var swTop = sw.classList.contains('rw-switch--top'); // donkere topbar-variant: geen gekleurde schaduw
    function swPlace(opt, animate) {
      if (!ind || !opt) return;
      if (!animate) ind.style.transition = 'none';
      ind.style.left = opt.offsetLeft + 'px';
      ind.style.width = opt.offsetWidth + 'px';
      var buy = (opt === swBuy);
      ind.style.background = buy ? '#1E63C7' : '#1F7A5A';
      ind.style.boxShadow = swTop ? 'none' : (buy ? '0 4px 12px -5px rgba(30,99,199,.45)' : '0 4px 12px -5px rgba(31,122,90,.45)');
      swOpts.forEach(function (o) { o.classList.toggle('is-current', o === opt); });
      if (!animate) { void ind.offsetWidth; ind.style.transition = ''; }
    }
    // alleen een zichtbare instantie speelt de aankomst; verborgen (drawer/andere breakpoint) staat direct goed
    var arriving = rwSwArriving && !!swOther && sw.getClientRects().length > 0;
    function swRest() { swPlace(swActive, arriving); }
    rwSwitchPlacers.push(swRest);
    sw.classList.add('is-ready'); /* Interaction-gate tip 2: tot dit moment vult CSS de actieve kant (geen pill-loze paint) */
    if (arriving) {
      swPlace(swOther, false);
      sw.classList.add('is-arriving');
      var swWent = false;
      var swGo = function () {
        if (swWent) return; swWent = true;
        swPlace(swActive, true);
        setTimeout(function () { arriving = false; sw.classList.remove('is-arriving'); }, 420);
      };
      requestAnimationFrame(function () { setTimeout(swGo, 60); });
      setTimeout(swGo, 600); /* vangnet (Interaction-gate tip 2): ook bij drukke main thread staat de vorige modus er hooguit ~600ms */
    } else {
      swRest();
    }
    window.addEventListener('load', swRest);
    window.addEventListener('resize', function () { swPlace(swActive, false); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { arriving = false; sw.classList.remove('is-arriving'); sw.classList.remove('is-leaving'); swPlace(swActive, false); } });
    swOpts.forEach(function (o) { o.addEventListener('mouseenter', function () { if (!sw.classList.contains('is-leaving')) swPlace(o, true); }); });
    sw.addEventListener('mouseleave', function () { if (!sw.classList.contains('is-leaving')) swPlace(swActive, true); });
    swOpts.forEach(function (o) {
      o.addEventListener('click', function (e) {
        if (o === swActive || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        swPlace(o, true);              // indicator + kleur wisselen terwijl de nieuwe pagina laadt
        sw.classList.add('is-leaving'); // hover-uit mag hem niet terugtrekken
        setTimeout(function () {       // Interaction-gate tip 5: navigatie geannuleerd/mislukt zonder unload -> terug naar de echte modus
          if (document.visibilityState === 'visible' && sw.classList.contains('is-leaving')) { sw.classList.remove('is-leaving'); swPlace(swActive, true); }
        }, 8000);
      });
    });
  });

  // UX2026: mobiele zoekrij opent de bestaande fullscreen-overlay
  /* W15-2c r1 (Visual B1, nawerk): in de smalle zoekbalk van 900-1060 px kapte de lange placeholder af ('Zoek naar consoles, games,') — daar de korte */
  (function () {
    var inp = document.querySelector('.rw-bar-search input[data-ph-kort]'); if (!inp || !window.matchMedia) return;
    var mq = window.matchMedia('(min-width: 900px) and (max-width: 1060px)');
    function ph() { inp.placeholder = mq.matches ? inp.getAttribute('data-ph-kort') : inp.getAttribute('data-ph-lang'); }
    ph(); if (mq.addEventListener) mq.addEventListener('change', ph); else if (mq.addListener) mq.addListener(ph);
  })();
  var msRow = document.getElementById('rw-msearchrow-btn');
  if (msRow) msRow.addEventListener('click', openSearchOv);

  // W7-1 (A11y-gate W6-9: 43 onzichtbare focusstops + honderden tab-stops door :focus-within):
  // megamenu als disclosure-navigatie (APG): Tab loopt alleen langs de categorielinks; het paneel
  // opent expliciet met pijl-omlaag (of Alt+pijl-omlaag) en focust de eerste link; Escape sluit en
  // zet focus terug op de categorielink; focus die het item verlaat sluit het paneel. Enter blijft
  // gewoon naar de collectie navigeren. Hover-gedrag (CSS) blijft ongewijzigd.
  if (document.body.classList.contains('rw-redesign')) {
    function kbClose(mega, refocus) {
      if (!mega || !mega.classList.contains('is-kbopen')) return;
      mega.classList.remove('is-kbopen');
      var item = mega.closest('.rw-catbar__item');
      var top = item && item.querySelector('.rw-catbar__link');
      if (top) { top.setAttribute('aria-expanded', 'false'); if (refocus) top.focus(); }
    }
    function kbCloseAll(except) {
      document.querySelectorAll('.rw-mega.is-kbopen').forEach(function (m) { if (m !== except) kbClose(m, false); });
    }
    document.addEventListener('keydown', function (e) {
      var ae = document.activeElement;
      if (!ae || !ae.closest) return;
      var item = ae.closest('.rw-catbar__item');
      if (!item) return;
      var mega = item.querySelector('.rw-mega');
      if (!mega) return;
      if (e.key === 'ArrowDown' && ae.classList.contains('rw-catbar__link')) {
        e.preventDefault();
        kbCloseAll(mega);
        mega.classList.add('is-kbopen');
        ae.setAttribute('aria-expanded', 'true');
        var first = mega.querySelector('a[href], button');
        /* uitgesteld: het vintage-paneel transitioneert visibility en is op het open-moment zelf nog niet focusbaar */
        if (first) setTimeout(function () { first.focus(); }, 40);
      } else if (e.key === 'Escape') {
        kbClose(mega, true);
      }
    });
    document.addEventListener('focusin', function (e) {
      document.querySelectorAll('.rw-mega.is-kbopen').forEach(function (m) {
        var item = m.closest('.rw-catbar__item');
        if (item && !item.contains(e.target)) kbClose(m, false);
      });
    });
  }
  window.__rwHeaderReady = true;
  if (typeof window.__rwHeaderRelease === 'function') window.__rwHeaderRelease();
})();
